import axios from 'axios'
import { RootStore } from '../data/store/'
import { APIEndPoints } from './APIEndpoints'
import { BASE_URL, sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data?.data
  return respData
}

const uploadFileReq = async (mid: string, fileName: string, _fileSize: string, tokens: any, file: any) => {
  const body = {
    fileName: fileName,
    transactionType: 211,
    initiatingEntityId: 2103,
    entityId: mid,
  }

  var data = new FormData()
  data.append('file', file)
  data.append('filerequest ', JSON.stringify(body))

  const config = {
    onUploadProgress: (progressEvent: any) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      if (!isNaN(percentCompleted)) {
        RootStore.settings.metaData.setFileUploadProgress(percentCompleted)
      }
    },
    headers: {
      ...sitConfig(tokens).headers,
      'Content-Type': 'multipart/form-data',
      formData: true,
      parseReqBody: true,
    },
  }
  let response = await axios.post(`${BASE_URL}${APIEndPoints.BulkFileUpload}`, data, config).catch((err) => {
    RootStore?.response?.setMessage(err?.data?.error?.message ?? 'Error while processing request')
  })
  return responseParser(response)
}

export { uploadFileReq }
